import { EntitledToView } from '@news-mono/web-common'
import React from 'react'
import {
    StyledPromoCard,
    StyledPromoImg,
    StyledPromoLink,
} from '../PromoCard.styled'

const EntitledView = () => {
    const promo = require('../assets/summer-of-cricket-logged-in.png')

    return (
        <StyledPromoCard promotion="summer-of-cricket">
            <StyledPromoLink to="https://thewest.com.au/ashesmagread">
                <StyledPromoImg
                    src={promo}
                    alt="Read the Digital Cricket Magazine"
                />
            </StyledPromoLink>
        </StyledPromoCard>
    )
}

const OpportunityView = () => {
    const promo = require('../assets/summer-of-cricket-logged-out.png')
    return (
        <StyledPromoCard promotion="summer-of-cricket">
            <StyledPromoLink to="https://subscriber.thewest.com.au/offercheck/thewest?redirect=true&offerCode=CRKT25_1">
                <StyledPromoImg
                    src={promo}
                    alt="Get access to the digital mag now - Find out how"
                />
            </StyledPromoLink>
        </StyledPromoCard>
    )
}

export const SummerOfCricketPromoCard = () => {
    return (
        <EntitledToView
            requiredAccess={{ level: 'subscriber' }}
            entitled={() => {
                return <EntitledView />
            }}
            notEntitled={() => {
                return <OpportunityView />
            }}
        />
    )
}
